























import {Component, Prop, Vue} from 'vue-property-decorator'
import {IPoint} from '@/entities'

@Component
export default class TravelPoint extends Vue {
  @Prop() readonly data!: IPoint

  get cityPath(): string {
    return this.data.city?.path as string;
  }
}
